import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

// PrimeVue primeiro para não interferir no layout do vuetify
import PrimeVue from 'primevue/config';
Vue.use(PrimeVue);
/* import 'primevue/resources/themes/saga-blue/theme.css'; */
import 'primevue/resources/themes/md-light-indigo/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';

import vuetify from './plugins/vuetify'
Vue.config.productionTip = false

// Vuesax styles
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css'
import 'material-icons/iconfont/material-icons.css';
Vue.use(Vuesax)

import VueResource from 'vue-resource';
Vue.use(VueResource);
Vue.http.options.root = "https://api.genesysinf.com.br/webapi/api"   // Se Hospedado fora da SH
//Vue.http.options.root = "http://localhost:2988/api"                  // Teste local
Vue.http.options.timeout = 999999;

import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
Vue.use(BootstrapVue);

import VueSession from 'vue-session';
Vue.use(VueSession)

import rFunc32 from "./rFunc/rFunc32.js";
Vue.use(rFunc32)

import Dialog from 'vue-dialog-loading'
Vue.use(Dialog, {
  dialogBtnColor: '#0f0'
})

import VueTheMask from 'vue-the-mask';
Vue.use(VueTheMask);

import VueNumeric from 'vue-numeric';
Vue.use(VueNumeric);

import mask from 'vuejs-mask'
Vue.use(mask)

window.$ = require('jquery');
window.JQuery = require('jquery');

import './css/index.css';

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
